module.exports = __webpack_public_path__ + "static/img/home-product.d96bb199.png";